<template>
  <card>
    <list
      v-if="$store.state.user.sections['alif-orders']"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="false"
      :itemLink="itemLink"
      :setImport="false"
      :exportFields="exportFields"
      :staticFilters="staticFilters"
      :setLink="setLink"
      :openItem="false"
      :fields="fields"
      :filters="filters"
      :params="params"
      :searchDisable="false"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
      :dateFilter="dateFilter"
    />
    <h4 v-else>{{ "no_acccess" | setText("НЕТ ДОСТУПА") }}</h4>
  </card>
</template>
<script>
export default {
  watch: {},
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      exportFields: {
        "CB ID": {
          field: "order",
          callback: (val) => {
            try {
              return val.id;
            } catch (error) {
              return "-";
            }
          },
        },
        "UZUM ID": {
          field: "exchange_additional_id",
          callback: (val) => {
            try {
              return val;
            } catch (error) {
              return "-";
            }
          },
        },

        "Загружен акт": {
          field: "act",
          callback: (val) => {
            return val ? "Да" : "Нет";
          },
        },
        "Загружено фото клиента": {
          field: "client_product",
          callback: (val) => {
            return val ? "Да" : "Нет";
          },
        },

        Локация: {
          field: "shop.name",
          callback: (val) => {
            try {
              return val;
            } catch (error) {
              return "";
            }
          },
        },
        Оператор: {
          field: "user.name",
          callback: (val) => {
            try {
              return val;
            } catch (error) {
              return "";
            }
          },
        },
        "Номер оператора": {
          field: "user.phone",
          callback: (val) => {
            try {
              return val;
            } catch (error) {
              return "";
            }
          },
        },
        "Подписанный акт": {
          field: "act",
          callback: (val) => {
            try {
              return val;
            } catch (error) {
              return "";
            }
          },
        },
        "Фото клиента": {
          field: "client_product",
          callback: (val) => {
            try {
              return val;
            } catch (error) {
              return "";
            }
          },
        },
        Дата: {
          field: "created_at",
          callback: (val) => {
            try {
              if (val && typeof val == "string") {
                let date = new Date(val);
                return date.toLocaleString();
              }
              return "Нет даты";
            } catch (error) {
              return val;
            }
          },
        },
      },
      filters: [
        // {
        //   key: "shop",
        //   title: "Фильтр по торговым точкам",
        //   titleKey: "shop_filter",
        //   field_key: "shop",
        //   selectKey: "name",
        // },
        // {
        //   key: "organization",
        //   title: "Фильтр по организациям",
        //   titleKey: "organization_filter",
        //   field_key: "organization",
        //   selectKey: "name",
        // },
      ],
      staticFilters: [
        {
          title: "Статус",
          key: "status",
          default: "0",
          items: [
            {
              id: "0",
              title: "Показать все",
            },
            {
              id: "1",
              title: "В процессе",
            },
            {
              id: "-1",
              title: "Отменен",
            },
            {
              id: "2",
              title: "Выполнен",
            },
          ],
        },
      ],
      params: {},
      val: [],
      modalCreate: "role",
      fields: [],
      dateFilter: [
        {
          key: "from_at",
          titleKey: "from_at",
          title: "Начало даты",
        },
        {
          key: "till_at",
          titleKey: "till_at",
          title: "Конец даты",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_alif_order",
      itemLink: "partner/alif-transactions",
      setLink: "partner/alif-transactions",
      columns: [
        {
          detail: true,
        },
        {
          key: "order",
          title: "Номер",
          object: "id",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          disableLink: true,
        },
        {
          key: "display_status",
          title: "Статус",
          object: "id",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          disableLink: true,
          full: true,
        },

        {
          key: "act_original",
          title: "Договор",
          checkbox: false,
          control: false,
          link: true,
          disableLink: true,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "act",
          title: "Договор подписанный",
          checkbox: false,
          control: false,
          link: true,
          disableLink: true,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "shop",
          title: "Локация",
          object: "name",
          checkbox: false,
          control: false,
          align: "left",
          full: true,
          detail: false,
          disableLink: true,
        },
        {
          key: "order",
          title: "Сумма заказа",
          object: "price_total",
          checkbox: false,
          control: false,
          align: "left",
          full: true,
          detail: false,
          disableLink: true,
          price: true,
        },
        {
          key: "limit",
          title: "Выделенный лимит",
          full: true,
          price: true,
        },
        {
          key: "order_user_phone",
          title: "Номер оператора",
          full: true,
        },
        {
          key: "user",
          title: "Оператор",
          object: "name",
          disableLink: true,
          full: true,
        },
        {
          key: "created_at",
          title: "",
          align: "right",
          dateTimeFormat: true,
          full: true,
        },
        {
          detail: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
